export default __webpack_public_path__ + "static/media/bossa.fe4bfacf.webm";